/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import $ from 'jquery';
import ReactSvgLineChart from 'react-svg-line-chart';
import ReactTooltip from 'react-tooltip';
import { ReactSVG } from 'react-svg';
import archiveLockSvg from '../../../../assets/images/component/svg/archive-lock-icon-2.svg';
import { getPortfolio } from '../../portfolio/selectors/portfolio';
import {
  hideOptionalCommentRightPanel,
  updateOptionalCommentRightPanel,
} from '../../portfolio/actions/portfolio';
import {
  getOptionalCommentResponses,
  getAutomatedQuestions,
  deleteCustomQuestionsData,
  deleteCustomQuestion,
  getSegmentGroupStakeholderCounts,
  isChecking,
} from '../actions/project';
import MultiColorProgressBar from '../../../ui-components/MultiColorProgressBar';
import AddCustomQuestion from '../../../ui-components/CustomQuestion/AddCustomQuestion.jsx';
import { Spinner } from '../../../ui-components/Loader';
import RenderIf from '../../../ui-components/Common';
import { YESNO_QUESTION, OPENTYPE_QUESTION, INITIAL_HTML_RENDER } from '../../../Constants';
import DeleteConfirmation from '../../../ui-components/DeleteConfirmation/DeleteConfirmation.jsx';
import { checkArrayContainsSomeValues, checkObjectKeysHaveValues } from '../../../utils/helper';
import customDomainSvg from '../../../../assets/images/component/svg/custom-domain.svg';
import customQuestionSvg from '../../../../assets/images/component/svg/custom-question-active.svg';
import autoGenerateQuestionSvg from '../../../../assets/images/component/svg/auto-generated-question-active.svg';
import SegmentToolTip from '../../../ui-components/SegmentToolTip/SegmentToolTip.jsx';
import { showHideOverlay } from '../../common/overlay/actions/overlay';
import RightFlyPanProgressDecision from './RightFlyPanProgressDecision';

const mapStateToProps = state => ({
  portfolioData: getPortfolio(state),
  optionalCommentRightPanel: state.portfolio.portfolioData.optionalCommentRightPanel,
  customQuestionBasket: state.project.customQuestionBasket,
  roles: state.portfolio.portfolioData.roles,
  isSysAdmin: state.login.isSysAdmin,
  projectSegments: state.project.projectSegments,
  overAllWidget: state.project.overAllWidget,
  segmentGroupDashboardData: state.project.segmentGroupDashboardData,
  segmentGroupValue: state.project.segmentGroupValue,
  segmentGroupOverall: state.project.segmentGroupOverall,
  selectedSegment: state.project.selectedSegment,
  project: state.project,
});

const mapDispatchToProps = {
  hideOptionalCommentRightPanel,
  getOptionalCommentResponses,
  getAutomatedQuestions,
  deleteCustomQuestionsData,
  deleteCustomQuestion,
  getSegmentGroupStakeholderCounts,
  updateOptionalCommentRightPanel,
  showHideOverlay,
  isChecking,
};

const trendBlurData = [
  { x: 1, y: 58 },
  { x: 2, y: 58 },
  { x: 3, y: 73 },
  { x: 4, y: 64 },
  { x: 5, y: 13 },
  { x: 6, y: 24 },
  { x: 7, y: 92 },
];

class OptionalCommentsRightPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedInUserId: 0,
      stakeholders: [],
      isLoading: true,
      attributeTitle: '',
      domainTitle: '',
      attributeDesription: '',
      customQuestionsIncluded: false,
      commentResponses: [],
      commentResponsecopy: [],
      isShowCommentPanelData: false,
      showAddCustomQuestionModel: false,
      moreCustomQuestion: [],
      customQuestionDeployed: false,
      questionModel: {},
      showDeleteModal: false,
      selectedQuestionId: 0,
      selectedQuestionIndex: 0,
      isProjectAnonymityMet: false,
      projectDraftedStatus: false,
      isAutomatedQuestion: false,
      activePoint: [],
      activePosition: null,
      trendData: [],
      activeSegment: '',
      activeSegmentName: null,
      isDomainAnonymityOverride: false,
      showTrendLines: false,
      isAttributeAnonymityPass: false,
      futureDropCustomQuestions: [],
    };
    this.hideOptionalCommentRightPanel = this.hideOptionalCommentRightPanel.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  componentDidMount() {
    const { portfolioData, segmentGroupValue, segmentGroupOverall } = this.props;
    const {
      segmentGroup2, segmentGroup3, segmentGroup4,
    } = segmentGroupOverall;
    const { optionalCommentRightPanel } = portfolioData;
    const { associatedStakeholdersCount, filterGroupValues } = optionalCommentRightPanel;

    const {
      isAttrAssociateWithGroupA,
      isAttrAssociateWithGroupB,
      isAttrAssociateWithGroupC,
      isAttrAssociateWithGroupD,
    } = this.getActiveSegmentData(false);
    switch (true) {
      case isAttrAssociateWithGroupA:
        this.setState({
          activeSegmentName: filterGroupValues.length ? associatedStakeholdersCount : segmentGroupValue.segmentGroup1,
        });
        this.getOptionalComment(optionalCommentRightPanel);
        break;
      case isAttrAssociateWithGroupB:
        this.setState({
          activeSegmentName: filterGroupValues.length ? associatedStakeholdersCount : segmentGroupValue.segmentGroup2,
        });
        this.getOptionalComment({ ...optionalCommentRightPanel, selectedSegment: segmentGroupValue.segmentGroup2, isProjectAnonymityMet: segmentGroup2.isOptionalCommentAnonymity });
        break;
      case isAttrAssociateWithGroupC:
        this.setState({
          activeSegmentName: filterGroupValues.length ? associatedStakeholdersCount : segmentGroupValue.segmentGroup3,
        });
        this.getOptionalComment({ ...optionalCommentRightPanel, selectedSegment: segmentGroupValue.segmentGroup3, isProjectAnonymityMet: segmentGroup3.isOptionalCommentAnonymity });
        break;
      case isAttrAssociateWithGroupD:
        this.setState({
          activeSegmentName: filterGroupValues.length ? associatedStakeholdersCount : segmentGroupValue.segmentGroup4,
        });
        this.getOptionalComment({ ...optionalCommentRightPanel, selectedSegment: segmentGroupValue.segmentGroup4, isProjectAnonymityMet: segmentGroup4.isOptionalCommentAnonymity });
        break;
      default:
        this.setState({
          activeSegmentName: filterGroupValues.length ? associatedStakeholdersCount : segmentGroupValue.segmentGroup1,
        });
        this.getOptionalComment(optionalCommentRightPanel);
        break;
    }
  }

  getOptionalComment(optionalCommentRightPanel) {
    const { isCustomAttribute } = optionalCommentRightPanel;
    this.props.getOptionalCommentResponses(optionalCommentRightPanel).then((res) => {
      const {
        attributeTitle,
        domainTitle,
        attributeDescription,
        customQuestionsIncluded,
        commentResponses,
        isShowCommentPanelData,
        moreCustomQuestion,
        isProjectAnonymityMet,
        isAttributeAnonymityPass,
        projectDraftedStatus,
        trendData,
        stakeHolders,
        showTrendLines,
        isDomainAnonymityOverride,
        futureDropCustomQuestions,
      } = res;
      const updateTrendDateFormat = trendData.map((trend) => {
        if (trend.date.includes(' till ')) {
          const splitDate = trend.date.split('till');
          const removeSpaceDate = splitDate.map(value => value.trim());
          const startDate = removeSpaceDate[0];
          const endDate = removeSpaceDate[1];
          return ({ ...trend, date: `${moment(startDate).format('DD/MM')} till ${moment(endDate).format('DD/MM')}` });
        }
        return ({ ...trend, date: moment(trend.date).format('DD/MM') });
      });
      this.setState({
        attributeTitle,
        domainTitle,
        attributeDescription,
        customQuestionsIncluded,
        commentResponses,
        isShowCommentPanelData,
        isLoading: false,
        isCustomAttribute,
        moreCustomQuestion,
        isProjectAnonymityMet,
        isAttributeAnonymityPass,
        projectDraftedStatus,
        trendData: updateTrendDateFormat,
        stakeHolders,
        isDomainAnonymityOverride,
        showTrendLines,
        futureDropCustomQuestions,
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    const { optionalCommentRightPanel } = nextProps.portfolioData;
    if (this.state.attributeTitle !== optionalCommentRightPanel.attributeTitle && optionalCommentRightPanel.attributeTitle !== '') {
      this.setState({ isLoading: true });
      this.getOptionalComment(optionalCommentRightPanel);
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  hideOptionalCommentRightPanel() {
    this.props.hideOptionalCommentRightPanel();
    this.props.showHideOverlay(false);
  }

  openCustomQuestionOptions(index) {
    if ($(`#collapsed-header-2${index}`).hasClass('card-open')) {
      $(`#collapsed-header-2${index}`).removeClass('card-open');
      $(`.close-${index}`).show();
      $(`.open-${index}`).hide();
    } else {
      $(`#collapsed-header-2${index}`).addClass('card-open');
      $(`.close-${index}`).hide();
      $(`.open-${index}`).show();
    }


    $('.cardclass').removeClass('zindex');

    $(`#collapsed-header-3${index}`).addClass('zindex');
  }

  getActiveSegmentData(isRender) {
    const { portfolioData, segmentGroupDashboardData } = this.props;
    const { optionalCommentRightPanel } = portfolioData;
    const {
      segmentGroupData1, segmentGroupData2,
      segmentGroupData3, segmentGroupData4,
    } = segmentGroupDashboardData;
    const domainWidgets = segmentGroupData1?.DomainWidgets;
    const domainWidgets2 = segmentGroupData2?.DomainWidgets;
    const domainWidgets3 = segmentGroupData3?.DomainWidgets;
    const domainWidgets4 = segmentGroupData4?.DomainWidgets;
    const widgetDomainData = domainWidgets && domainWidgets.find(item => item.domainId === optionalCommentRightPanel.domainID);
    const widget2DomainData = domainWidgets2 && domainWidgets2.find(item => item.domainId === optionalCommentRightPanel.domainID);
    const widget3DomainData = domainWidgets3 && domainWidgets3.find(item => item.domainId === optionalCommentRightPanel.domainID);
    const widget4DomainData = domainWidgets4 && domainWidgets4.find(item => item.domainId === optionalCommentRightPanel.domainID);
    const isAttrAssociateWithGroupA = widgetDomainData && widgetDomainData.attributes.some(attr => attr.id === optionalCommentRightPanel.attributeId && attr.isAttrAssociatedWithQuestions);
    const isAttrAssociateWithGroupB = widget2DomainData && widget2DomainData.attributes.some(attr => attr.id === optionalCommentRightPanel.attributeId && attr.isAttrAssociatedWithQuestions);
    const isAttrAssociateWithGroupC = widget3DomainData && widget3DomainData.attributes.some(attr => attr.id === optionalCommentRightPanel.attributeId && attr.isAttrAssociatedWithQuestions);
    const isAttrAssociateWithGroupD = widget4DomainData && widget4DomainData.attributes.some(attr => attr.id === optionalCommentRightPanel.attributeId && attr.isAttrAssociatedWithQuestions);
    if (!isRender) {
      switch (true) {
        case isAttrAssociateWithGroupA:
          this.setState({ activeSegment: 'A' });
          break;
        case isAttrAssociateWithGroupB:
          this.setState({ activeSegment: 'B' });
          break;
        case isAttrAssociateWithGroupC:
          this.setState({ activeSegment: 'C' });
          break;
        case isAttrAssociateWithGroupD:
          this.setState({ activeSegment: 'D' });
          break;
        default:
          break;
      }
    }
    return {
      isAttrAssociateWithGroupA,
      isAttrAssociateWithGroupB,
      isAttrAssociateWithGroupC,
      isAttrAssociateWithGroupD,
    };
  }


  addAutomatedQuestions() {
    const projectId = this.props.portfolioData.selectedProjectId;
    const {
      attributeId, userFilterGroupValue, filterGroupValues,
      associatedStakeholdersCount,
      domainID, dSegments,
    } = this.props.optionalCommentRightPanel;
    const {
      projectSegments,
    } = this.props;
    const item = {
      projectId,
      attributeId,
      domainId: domainID,
      isSentToAllStakeHolders: true,
    };

    const segmentFiltersGroup = [];
    dSegments.forEach((x) => {
      const selectedSegment = projectSegments
        .find(s => parseInt(s.value, 10) === parseInt(x, 10));
      segmentFiltersGroup.push(selectedSegment.text.split(','));
    });

    this.props.getSegmentGroupStakeholderCounts(
      { ProjectId: projectId, segments: dSegments },
    ).then((d) => {
      const userFilterData = {
        filterGroupValues: filterGroupValues?.length > 0 ? filterGroupValues : segmentFiltersGroup,
        createSegment: filterGroupValues?.length > 0 ? 'yes' : 'no',
        userFilterGroupValues: userFilterGroupValue,
        associatedStakeholdersCount: filterGroupValues?.length > 0
          ? associatedStakeholdersCount : d ?? null,
        segments: dSegments,
        dSegments,
        segmentFiltersGroup,
      };
      if (projectId) {
        this.props.getAutomatedQuestions(item, userFilterData);
      }
    });
  }

  editCustomQuestion(model, isDeployed) {
    this.setState({
      showAddCustomQuestionModel: true,
      customQuestionDeployed: isDeployed,
      questionModel: model,
    });
  }

  cancelCustomQuestion() {
    const { optionalCommentRightPanel } = this.props.portfolioData;
    this.getOptionalComment(optionalCommentRightPanel);
    this.setState({ showAddCustomQuestionModel: false });
  }

  openCustomquestionDeleteModal(questionId, questionIndex) {
    this.setState({
      selectedQuestionId: questionId, selectedQuestionIndex: questionIndex, showDeleteModal: true,
    });
  }

  deleteCustomQuestion() {
    const customQuestionsData = {
      questionId: this.state.selectedQuestionId,
    };
    return new Promise((resolve) => {
      this.props.deleteCustomQuestionsData(customQuestionsData).then((result) => {
        if (result.status === 200) {
          this.setState({ showDeleteModal: false });
          const {
            moreCustomQuestion,
            commentResponses,
            selectedQuestionId,
            selectedQuestionIndex,
          } = this.state;
          const newQuestionSet1 = moreCustomQuestion.filter(
            q => q.questionId !== selectedQuestionId,
          );
          const newQuestionSet2 = commentResponses.filter(
            q => q.questionId !== selectedQuestionId,
          );
          this.setState({
            moreCustomQuestion: newQuestionSet1,
            commentResponses: newQuestionSet2,
          });
          this.props.deleteCustomQuestion({ index: selectedQuestionIndex });
          this.props.hideOptionalCommentRightPanel();
          const valCheck = {
            value: true,
          };
          this.props.isChecking(valCheck);
        }
      });
      resolve(true);
    });
  }

  renderStakeholderSegment() {
    const { projectSegments } = this.props;
    const { stakeHolders, activeSegmentName } = this.state;

    // eslint-disable-next-line eqeqeq
    const selectedSegmentName = projectSegments.find(segment => segment.value == activeSegmentName) || {};
    return <div className="comments-heading-wrap1 p-28 p-b-0">
      <h6>
        {
          activeSegmentName === 0 || activeSegmentName === '0'
            ? 'For all stakeholders' : `For ${stakeHolders} stakeholder${stakeHolders > 1 ? 's' : ''}`
        }
      </h6>
      {
        activeSegmentName !== 0 && activeSegmentName !== '0'
          ? <span className='segment-name preview-pane-font'>{selectedSegmentName.text}</span> : null
      }
    </div>;
  }

  isRenderElement(isProjectAnonymityMet, isDomainAnonymityOverride, commentData, element) {
    const { type, response, progressBarData } = commentData;
    // eslint-disable-next-line camelcase
    const { minimum_stakeholder_percentage, minimum_stakeholder, maximum_stakeholder } = this.props.project.overAllWidget.project;
    const rightFlyPanProgressDecision = new RightFlyPanProgressDecision(this.props.project.projectStakeholdersCount, minimum_stakeholder_percentage, minimum_stakeholder, maximum_stakeholder);
    switch (element) {
      case INITIAL_HTML_RENDER.icon:
        return rightFlyPanProgressDecision.icon(isProjectAnonymityMet,
          isDomainAnonymityOverride, progressBarData,
          response, type, YESNO_QUESTION);
      case INITIAL_HTML_RENDER.progressBarSection:
        return rightFlyPanProgressDecision.progressBarSection(isProjectAnonymityMet,
          isDomainAnonymityOverride, progressBarData);
      case INITIAL_HTML_RENDER.commentSection:
        return rightFlyPanProgressDecision.commentSection(isProjectAnonymityMet,
          isDomainAnonymityOverride, progressBarData,
          response);
      case INITIAL_HTML_RENDER.openTextQuestionSection:
        return rightFlyPanProgressDecision.openTextQuestionSection(isProjectAnonymityMet,
          isDomainAnonymityOverride, progressBarData,
          response, type, OPENTYPE_QUESTION);
      case INITIAL_HTML_RENDER.yesNoSection:
        return rightFlyPanProgressDecision.yesNoSection(isProjectAnonymityMet,
          isDomainAnonymityOverride, progressBarData,
          response, type, YESNO_QUESTION);
      case INITIAL_HTML_RENDER.openTextSection:
        return rightFlyPanProgressDecision.openTextSection(isProjectAnonymityMet,
          isDomainAnonymityOverride, progressBarData,
          response, type, OPENTYPE_QUESTION);
      default:
        return false;
    }
  }

  renderGroupName(group) {
    switch (true) {
      case group.isGroupA:
        return group.heading;
      case group.isGroupB:
        return group.heading;
      case group.isGroupC:
        return group.heading;
      case group.isGroupD:
        return group.heading;
      default:
        return '';
    }
  }

  render() {
    const {
      attributeTitle,
      domainTitle,
      attributeDescription,
      customQuestionsIncluded,
      commentResponses,
      isLoading,
      showAddCustomQuestionModel,
      isCustomAttribute,
      moreCustomQuestion,
      questionModel,
      showDeleteModal,
      projectDraftedStatus,
      isAutomatedQuestion,
      activePosition,
      activePoint,
      trendData = [],
      activeSegment,
      isDomainAnonymityOverride,
      isAttributeAnonymityPass,
      futureDropCustomQuestions,
    } = this.state;
    const {
      optionalCommentRightPanel, portfolioData, customQuestionBasket, roles, isSysAdmin,
      segmentGroupDashboardData,
      segmentGroupValue,
      projectSegments,
    } = this.props;
    const {
      isAttrAssociateWithGroupA,
      isAttrAssociateWithGroupB,
      isAttrAssociateWithGroupC,
      isAttrAssociateWithGroupD,
    } = this.getActiveSegmentData(true);
    const selectedSegmentCount = checkObjectKeysHaveValues(segmentGroupDashboardData);
    const segmentGroupList = [
      { heading: 'A', selectedSegment: segmentGroupValue.segmentGroup1, isGroupA: isAttrAssociateWithGroupA },
      { heading: 'B', selectedSegment: segmentGroupValue.segmentGroup2, isGroupB: isAttrAssociateWithGroupB },
      { heading: 'C', selectedSegment: segmentGroupValue.segmentGroup3, isGroupC: isAttrAssociateWithGroupC },
      { heading: 'D', selectedSegment: segmentGroupValue.segmentGroup4, isGroupD: isAttrAssociateWithGroupD },
    ];
    const segmentGroupStakeholders = segmentGroupList.splice(0, selectedSegmentCount === 4 ? selectedSegmentCount + 1 : selectedSegmentCount);
    const isAuthoriseToView = !!(isSysAdmin || roles.portfolioAdministrator || roles.projectAdministrator);
    const timzone = moment.tz.guess();
    const totalAutoQuestiosn = customQuestionBasket.automatedQuestions.reduce((x, y) => {
      x = [...x, ...y.questions];
      return x;
    }, []);
    const autoQuesCount = totalAutoQuestiosn
      .filter(x => x.attributeId === optionalCommentRightPanel.attributeId
        && x.domainId === optionalCommentRightPanel.domainID);
    let disableAttribute = false;
    customQuestionBasket.disableDomainAttribute.map((item) => {
      const arr = item.split(',');
      /* eslint-disable */
      if (optionalCommentRightPanel.attributeId === parseInt(arr[1])
        && optionalCommentRightPanel.domainID === parseInt(arr[0])) {
        disableAttribute = true;
      }
    });

    const handlePointHover = (activePoint, e) => {
      if (this.state.trendData && this.state.trendData.length > 0
        && e != null && activePoint != null) {
        $('body').addClass('hover-active-point');
        this.setState({
          activePoint,
          activePosition: {
            x: e.currentTarget.getAttribute('cx'),
            y: e.currentTarget.getAttribute('cy'),
            date: activePoint.date,
            score: activePoint.y,
          },
        });
      }
    }

    const hideTooltip = () => {
      $('body').removeClass('hover-active-point');
      this.setState({
        activePosition: null,
      });
    }
    const onClickGroupSegment = (group) => {
      this.setState({
        activeSegment: group.heading,
        activeSegmentName: group.selectedSegment,
        isLoading: true
      })
      const { segmentGroupOverall, portfolioData } = this.props
      const { segmentGroup1, segmentGroup2, segmentGroup3, segmentGroup4 } = segmentGroupOverall
      const { optionalCommentRightPanel } = portfolioData;
      switch (group.heading) {
        case 'A':
          this.props.updateOptionalCommentRightPanel({ selectedSegment: group.selectedSegment, isProjectAnonymityMet: segmentGroup1.isOptionalCommentAnonymity })
          this.getOptionalComment({ ...optionalCommentRightPanel, selectedSegment: group.selectedSegment, isProjectAnonymityMet: segmentGroup1.isOptionalCommentAnonymity });
          break;
        case 'B':
          this.props.updateOptionalCommentRightPanel({ selectedSegment: group.selectedSegment, isProjectAnonymityMet: segmentGroup2.isOptionalCommentAnonymity })
          this.getOptionalComment({ ...optionalCommentRightPanel, selectedSegment: group.selectedSegment, isProjectAnonymityMet: segmentGroup2.isOptionalCommentAnonymity });
          break;
        case 'C':
          this.props.updateOptionalCommentRightPanel({ selectedSegment: group.selectedSegment, isProjectAnonymityMet: segmentGroup3.isOptionalCommentAnonymity })
          this.getOptionalComment({ ...optionalCommentRightPanel, selectedSegment: group.selectedSegment, isProjectAnonymityMet: segmentGroup3.isOptionalCommentAnonymity });
          break;
        case 'D':
          this.props.updateOptionalCommentRightPanel({ selectedSegment: group.selectedSegment, isProjectAnonymityMet: segmentGroup4.isOptionalCommentAnonymity })
          this.getOptionalComment({ ...optionalCommentRightPanel, selectedSegment: group.selectedSegment, isProjectAnonymityMet: segmentGroup4.isOptionalCommentAnonymity });

      }

    }
    const { dSegments, filterGroupValues } = optionalCommentRightPanel
    const filterDomainSegmentsText = projectSegments
      .filter(projectSegment => dSegments
        .filter(domainSegment => projectSegment.value === domainSegment).length)
      .map(filterSegment => filterSegment.text);
    // eslint-disable-next-line max-len
    const showWarningMessage = checkArrayContainsSomeValues(filterDomainSegmentsText, filterGroupValues);
    return (
      <React.Fragment>

        <div className="right-sidebar add-project-sidebar progress-reset" ref={this.setWrapperRef}>
          <Spinner isLoading={isLoading} />
          <RenderIf showComponent={!isLoading}>
            <div className="right-bar custom-animation" style={{ position: "sticky" }}>
              <div className='top-section'>
                <div className="right-bar-head d-flex justify-content-between align-items-center">
                  <div className="right-bar-title">
                    <h4 className="mb-0 title domain-title-e">{domainTitle}</h4>
                  </div>
                  <div className="right-bar-close">
                    <button type="button" className="btn btn-sm bg-transparent w-h-a close p-0" onClick={this.hideOptionalCommentRightPanel}>
                      <span className="material-icons">close</span>
                    </button>
                  </div>
                </div>
                <div className="header-subline">
                  <span className="text-uppercase phrase-color">{attributeTitle}</span>
                </div>
                {isCustomAttribute && <div class="optional-comment-custom-tag">Custom</div>}
                <div className="rb-head-description py-2">
                  <small className="phrase-color d-font-12" >{attributeDescription} </small>
                </div>
                {!isCustomAttribute && customQuestionsIncluded && (
                  <span className="info-text small"><span class="material-icons">
                    info
                  </span>This excludes responses from the custom questions</span>
                )}
              </div>
              <div className='middle-section'>
                {
                  selectedSegmentCount <= 1 ?
                    <div className="stack-holder-timeline">
                      {this.renderStakeholderSegment()}
                      <div
                        className={`graph-line
                        ${!trendData || trendData.length < 2 ? " blur-graph" : ""}`}
                        onMouseLeave={hideTooltip}
                      >
                        {activePosition && (
                          <div
                            className="graph-tooltip"
                            style={{
                              left: `${activePosition.date && activePosition.date.includes('till') ? activePosition.x - 38 : activePosition.x - 33}px`,
                              top: `${parseFloat(activePosition.y) - 40}px`,
                            }}
                          >
                            <div className='date'>{activePosition.date}</div>
                            <div><b>{Math.round(activePosition.score)}%</b></div>
                          </div>
                        )}
                        {this.state.showTrendLines && <ReactSvgLineChart
                          data={
                            trendData && trendData.length >= 2
                              ? trendData.map((point) => ({
                                ...point,
                                active: point.x === activePoint.x,
                              }))
                              : trendBlurData.map((point) => ({
                                ...point,
                              }))
                          }
                          pointsOnHover={handlePointHover}
                          pointsIsHoverOnZone={true}
                          axisWidth={0}
                          gridWidth={0}
                          labelsVisible={false}
                          pathColor={!trendData || trendData.length < 2 ? "grey" : "#fa5928"}
                          pathVisible={true}
                          pointsColor={!trendData || trendData.length < 2 ? "grey" : "#fa5928"}
                          pointsRadius={3}
                          labelsCountY={20}
                          labelsStepX={1}
                          pointsStrokeColor={!trendData || trendData.length < 2 ? "grey" : "#fa5928"}
                          pointsStrokeWidth={2}
                          pointsVisible={true}
                          viewBoxHeight={50}
                          viewBoxWidth={356}
                        />}
                      </div>
                    </div> : <div className="multiple-segment-trend-line">
                      <div className="header"><span className="group">Group</span>
                        {
                          segmentGroupStakeholders.map((group, index) => {
                            return (<span
                              onClick={() => onClickGroupSegment(group)}
                              className={`group-number ${group.heading === activeSegment ? 'active' : ''}`} key={index}>
                              {this.renderGroupName(group)}
                            </span>)
                          })
                        }
                      </div>
                      <div className="stack-holder-timeline">
                        {this.renderStakeholderSegment()}                        <div
                          className={`graph-line
                          ${!trendData || trendData.length < 2 ? " blur-graph" : ""}`}
                          onMouseLeave={hideTooltip}
                        >
                          {activePosition && (
                            <div
                              className="graph-tooltip"
                              style={{
                                left: `${activePosition.date && activePosition.date.includes('till') ? activePosition.x - 38 : activePosition.x - 33}px`,
                                top: `${parseFloat(activePosition.y) - 40}px`,
                              }}
                            >
                              <div className='date'>{activePosition.date}</div>
                              <div><b>{Math.round(activePosition.score)}%</b></div>
                            </div>
                          )}
                          {this.state.showTrendLines && <ReactSvgLineChart
                            data={
                              trendData && trendData.length >= 2
                                ? trendData.map((point) => ({
                                  ...point,
                                  active: point.x === activePoint.x,
                                }))
                                : trendBlurData.map((point) => ({
                                  ...point,
                                }))
                            }
                            pointsOnHover={handlePointHover}
                            pointsIsHoverOnZone={true}
                            axisWidth={0}
                            gridWidth={0}
                            labelsVisible={false}
                            pathColor={!trendData || trendData.length < 2 ? "grey" : "#fa5928"}
                            pathVisible={true}
                            pointsColor={!trendData || trendData.length < 2 ? "grey" : "#fa5928"}
                            pointsRadius={3}
                            labelsCountY={20}
                            labelsStepX={1}
                            pointsStrokeColor={!trendData || trendData.length < 2 ? "grey" : "#fa5928"}
                            pointsStrokeWidth={2}
                            pointsVisible={true}
                            viewBoxHeight={50}
                            viewBoxWidth={356}
                          />}
                        </div>
                      </div>
                    </div>
                }
                {/* eslint-disable-next-line */}
                {((commentResponses && commentResponses.length > 0)
                  // eslint-disable-next-line
                  || (moreCustomQuestion && moreCustomQuestion.length > 0)
                  || (futureDropCustomQuestions && futureDropCustomQuestions.length > 0)) && (
                    <React.Fragment >
                      <div className="comments-heading-wrap1 p-28 p-t-0">
                        <h6>Questions & Responses</h6>
                      </div>
                      <div className="right-bar-body">
                        <div id="accordion" className="accordion right-bar-accordion project-ques-sidebar">
                          {commentResponses && commentResponses.length > 0
                            && commentResponses.map((data, index) => (
                              <React.Fragment>
                                <div key={index} id={`collapsed-header-3${index}`} className={data.response.length > 0 ? 'card border-bottom overflow-v card-open cardclass' : 'card border-bottom overflow-v cardclass'}>
                                  <div id={`collapsed-header-1${index}`} className={index === 0 ? 'card-header card-open' : 'card-header collapsed'} data-bs-toggle="collapse"
                                    href={`#collapsed-question-1${index}`}>
                                    <a className="card-title custom-question-wrapper" style={{ paddingTop: isCustomAttribute ? '0px' : '5px' }}>
                                      <div className="custom-question-container">

                                        <span className="custom-question"> {data.QuestionTitle}</span>
                                        {data.isActive === false ?
                                          <div
                                            data-tip="This question will not be sent in the future question cycle."
                                            data-for='toolTip1' data-place='left'>
                                            <button
                                              disabled
                                              style={{ background: 'transparent' }}
                                            >
                                              <mat-icon class="material-icons" style={{ fontSize: '19px' }}> delete </mat-icon>
                                            </button>
                                            <ReactTooltip className='next-cycle-tooltip' place='top' effect='solid'
                                              id="toolTip1"></ReactTooltip>
                                          </div> :
                                          <div className="cq-header-action">
                                            {data.customQuestion && data.isArchived && (
                                              <ReactSVG className="mr-2" id='stakeHoldersCanView' data-for='stakeHoldersCanView' data-tip='dash_tooltip' wrapper="svg" width="12px" height="12px" src={archiveLockSvg} />
                                            )}
                                            <ReactTooltip id='stakeHoldersCanView' className='archive_lck_tooltip' place='left'
                                              effect='solid'>
                                              This question is locked and cannot be edited/deleted as it relates
                                              to prior topics/organisations. If you would like to re-use this question
                                              but make changes, please create  a new question instead.
                                            </ReactTooltip>
                                            <SegmentToolTip
                                              projectSegments={projectSegments}
                                              selectedSegments={data.segmentIds}
                                              tooltipIdPostfix={index}
                                            />
                                            {data.customQuestion && (<span className="ml-2 custom-question-icon">
                                              <ReactSVG src={customDomainSvg} />
                                            </span>)}
                                            {this.isRenderElement(isAttributeAnonymityPass, isDomainAnonymityOverride, data, INITIAL_HTML_RENDER.icon) && (<span className={`fa fa-commenting ml-2 cm-color orange-color
                                        ${data.iconColor}`}>
                                            </span>)}
                                            {isCustomAttribute && !data.isArchived
                                              && <span className="q-icons ml-2 mt-1" >

                                                {/* <span class="material-icons">
                                              chat_bubble
                                        </span> */}
                                                {data.customQuestion && !data.isArchived && <div class="dropdown-icon">
                                                  <div class="footer-dropdowns" style={{zIndex:'999'}}>
                                                    {isAuthoriseToView && !roles.projectViewer && <i class="material-icons question-dd-click" data-target={`collapsed-header-3${index}`}
                                                      onClick={() => this.openCustomQuestionOptions(index)} >
                                                      more_horiz
                                                    </i>}
                                                    <div class="dropdown-menu dropdown-menu-right  a-shadow-sm border-0 a-user-setting-panel-one " x-placement="top-start">
                                                      <ul class="user-infor-list">
                                                        <li class="user-infor-list-item">
                                                          <a href="javascript:void(0)" onClick={(e) => { e.stopPropagation(); this.editCustomQuestion(data, data.isQuestionSent) }}>Edit</a>
                                                        </li>
                                                        <li class="user-infor-list-item">
                                                          <a href="javascript:void(0)" onClick={(e) => { e.stopPropagation(); this.openCustomquestionDeleteModal(data.questionId, index) }}>Delete</a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </div>}
                                              </span>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </a>
                                  </div>
                                  <div id={`collapsed-question-1${index}`} className={index === 0 ? 'card-body collapse  pt-2 show' : 'card-body collapse pt-2'}>
                                    {data.type === YESNO_QUESTION && (
                                      <React.Fragment >
                                        {this.isRenderElement(isAttributeAnonymityPass, isDomainAnonymityOverride, data, INITIAL_HTML_RENDER.progressBarSection)
                                          && (<MultiColorProgressBar
                                            showIcon={true}
                                            progressBarData={data.progressBarData} />)}

                                        {this.isRenderElement(isAttributeAnonymityPass, isDomainAnonymityOverride, data, INITIAL_HTML_RENDER.commentSection) && (
                                          <React.Fragment >
                                            <div id={`collapsed-header-2${index}`} className={`card-body collapsed ad-comments text-toggle `} data-bs-toggle="collapse"
                                              href={`#collapsed-question-2${index}`} onClick={() => this.openCustomQuestionOptions(index)}>
                                              <a className="nested-card-title">
                                                <span className={`close-text-acc open-${index}`}> View Additional Comments</span>
                                                <span className={`open-text-acc close-${index}`}> Collapse Additional Comments</span>
                                              </a>
                                            </div>
                                            <div id={`collapsed-question-2${index}`} className={`card-body ${data.response.length > 0 ? 'collapse opened' : 'collapse'} pt-2`} >
                                              {data.response.map(res => (
                                                <div className={`right-bar-item mb-3 ${data.type && data.type === YESNO_QUESTION ? res.bgColor : ''}`}>
                                                  <div className="d-flex align-items-center">
                                                    {data.type && data.type === YESNO_QUESTION && (<div className={`message-avatar ${res.bgColor.iconColor}`}>
                                                      <span className={`material-icons dot ${res.bgColor.iconBorderColor}`}>
                                                        {res.bgColor.icon}
                                                      </span>
                                                    </div>)}
                                                    <div className={`message-box ${data.type && data.type === YESNO_QUESTION ? res.bgColor.color : ''}`}>
                                                      <p dangerouslySetInnerHTML={{
                                                        __html: res.response_text,
                                                      }}></p>
                                                    </div>
                                                  </div>
                                                  <small className="message-info">{moment(res.response_received).tz(timzone).format('h:mm A, D MMMM YYYY')}</small>
                                                </div>
                                              ))}
                                            </div>
                                          </React.Fragment>
                                        )}
                                      </React.Fragment>
                                    )}
                                    {this.isRenderElement(isAttributeAnonymityPass, isDomainAnonymityOverride, data, INITIAL_HTML_RENDER.openTextQuestionSection)
                                      && data.response.map(res => (
                                        <div className={`right-bar-item mb-3 ${data.type && data.type === YESNO_QUESTION
                                          ? res.bgColor : ''}`}>
                                          <div className="d-flex align-items-center">
                                            {data.type && data.type === YESNO_QUESTION && (<div className={`message-avatar ${res.bgColor.iconColor}`}>
                                              <span className="material-icons">
                                                {res.bgColor.icon}
                                              </span>
                                            </div>)}
                                            <div className={`message-box ${data.type && data.type === YESNO_QUESTION ? res.bgColor.color : ''}`}>
                                              <p dangerouslySetInnerHTML={{
                                                __html: res.response_text,
                                              }}></p>
                                            </div>
                                          </div>
                                          <small className="message-info">{moment(res.response_received).tz(timzone).format('h:mm A, D MMMM YYYY')}</small>
                                        </div>
                                      ))}
                                    {this.isRenderElement(isAttributeAnonymityPass, isDomainAnonymityOverride, data, INITIAL_HTML_RENDER.yesNoSection) && (
                                      <div className="mt-3">
                                        <div className="no-comment-text">
                                          <small>Too few stakeholder responses to display results
                                            for this questions.</small>
                                        </div>
                                      </div>)}
                                    {this.isRenderElement(isAttributeAnonymityPass, isDomainAnonymityOverride, data, INITIAL_HTML_RENDER.openTextSection)
                                      && (
                                        <div className="mt-3">
                                          <div className="no-comment-text">
                                            <small>Too few stakeholder responses to display results
                                              for this questions.</small>
                                          </div>
                                        </div>)}
                                  </div>
                                </div>
                              </React.Fragment>
                            ))}
                          {
                            this.props.selectedSegment ? <>
                              {moreCustomQuestion && moreCustomQuestion.length > 0
                                && moreCustomQuestion.map((data, index) => {
                                  index = commentResponses.length + index;
                                  return (
                                    <React.Fragment>
                                      <div key={index} id={`collapsed-header-3${index}`} className="card border-bottom card-open overflow-v">
                                        <div id={`collapsed-header-1${index}`} className="card-header collapsed card-open mb-0" data-bs-toggle="collapse"
                                          href={`#collapsed-question-1${index}`}>
                                          <a className="card-title custom-question-wrapper">
                                            <div className="custom-question-container">

                                              <span className="custom-question"> {data.QuestionTitle} </span>
                                              <div className='cq-header-action'>
                                                {data.customQuestion && (<span className="custom-question-icon">
                                                  <ReactSVG src={customDomainSvg} />
                                                </span>)}
                                                {isCustomAttribute
                                                  && isAuthoriseToView && !roles.projectViewer && <span className="ml-2 mt-2 q-icons">
                                                    <div class="dropdown-icon">
                                                      <div class="footer-dropdowns">
                                                        <span class="material-icons" data-bs-toggle="dropdown">
                                                          more_horiz
                                                        </span>
                                                        <div class="dropdown-menu dropdown-menu-right  a-shadow-sm border-0 a-user-setting-panel-one " x-placement="top-start">
                                                          <ul class="user-infor-list">
                                                            <li class="user-infor-list-item">
                                                              <a href="javascript:void(0)" onClick={(e) => { e.stopPropagation(); this.editCustomQuestion(data, data.isQuestionSent) }}>Edit</a>
                                                            </li>
                                                            <li class="user-infor-list-item">
                                                              <a href="javascript:void(0)" onClick={(e) => { e.stopPropagation(); this.openCustomquestionDeleteModal(data.questionId) }}>Delete</a>
                                                            </li>
                                                          </ul>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </span>
                                                }
                                              </div>
                                            </div>
                                            {data.icon && (<span className={`material-icons ${data.type === YESNO_QUESTION ? 'skip-icon-cstm-size' : 'appkiticon icon-comment-fill'} ${data.iconColor}`}>
                                              {data.type === YESNO_QUESTION ? data.icon : null}
                                            </span>)}
                                          </a>
                                        </div>
                                        <div id={`collapsed-question-1${index}`} className="card-body collapse pt-2">
                                          <div className="mt-3">
                                            <div className="no-comment-text">
                                              <small>Too few stakeholder responses to display results
                                                for this questions.</small>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </React.Fragment>
                                  );
                                })}
                            </> : null
                          }
                          {futureDropCustomQuestions && futureDropCustomQuestions.length > 0
                            && futureDropCustomQuestions.map((data, index) => {
                              index = commentResponses.length + index;
                              return (
                                <React.Fragment>
                                  <div key={index} id={`collapsed-header-3${index}`} className="card border-bottom card-open overflow-v">
                                    <div >
                                      <a className="card-title custom-question-wrapper">
                                        <div className="custom-question-container">

                                          <span className="fq-font preview-pane-font"> {data.QuestionTitle} </span>
                                          <div className='cq-header-action'>
                                            <SegmentToolTip
                                              projectSegments={projectSegments}
                                              selectedSegments={data.segmentIds}
                                              tooltipIdPostfix={index}
                                            />
                                            {data.customQuestion && data.isArchived && (
                                              <ReactSVG className="mr-2" id='stakeHoldersCanView' data-for='stakeHoldersCanView' data-tip='dash_tooltip' wrapper="svg" width="12px" height="12px" src={archiveLockSvg} />
                                            )}
                                            <ReactTooltip id='stakeHoldersCanView' className='archive_lck_tooltip' place='left'
                                              effect='solid'>
                                              This question is locked and cannot be edited/deleted as it relates
                                              to prior topics/organisations. If you would like to re-use this question
                                              but make changes, please create  a new question instead.
                                            </ReactTooltip>
                                            {data.customQuestion && (<span className="ml-2 custom-question-icon">
                                              <ReactSVG src={customDomainSvg} />
                                            </span>)}
                                            {data.customQuestion && (<span data-for={'nextcycle' + index} data-tip='tooltip' className="material-icons custom-question-icon cm-color orange-color ml-2 custom-question-icon">
                                              schedule_send
                                            </span>)}
                                            {data.customQuestion && <ReactTooltip id={'nextcycle' + index} className='next-cycle-tooltip' place='top'
                                              effect='solid'>
                                              Question will be sent in the next question cycle.
                                            </ReactTooltip>}
                                            {isCustomAttribute && !data.isArchived
                                              && isAuthoriseToView && !roles.projectViewer && <span className="ml-2 mt-2 q-icons">
                                                <div class="dropdown-icon">
                                                  <div class="footer-dropdowns">
                                                    {isAuthoriseToView && !roles.projectViewer && <i class="material-icons question-dd-click" data-target={`collapsed-header-3${index}`}
                                                      onClick={() => this.openCustomQuestionOptions(index)} >
                                                      more_horiz
                                                    </i>}
                                                    <div class="dropdown-menu dropdown-menu-right  a-shadow-sm border-0 a-user-setting-panel-one " x-placement="top-start">
                                                      <ul class="user-infor-list">
                                                        <li class="user-infor-list-item">
                                                          <a href="javascript:void(0)" onClick={(e) => { e.stopPropagation(); this.editCustomQuestion(data, data.isQuestionSent) }} disabled>Edit</a>
                                                        </li>
                                                        <li class="user-infor-list-item">
                                                          <a href="javascript:void(0)" onClick={(e) => { e.stopPropagation(); this.openCustomquestionDeleteModal(data.questionId, index) }}>Delete</a>
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </div>
                                                </div>
                                              </span>
                                            }
                                          </div>
                                        </div>
                                        {data.icon && (<span className={`material-icons ${data.type === YESNO_QUESTION ? 'skip-icon-cstm-size' : 'appkiticon icon-comment-fill'} ${data.iconColor}`}>
                                          {data.type === YESNO_QUESTION ? data.icon : null}
                                        </span>)}
                                      </a>
                                    </div>
                                    <div id={`collapsed-question-1${index}`} className="card-body collapse pt-2">
                                      <div className="mt-3">
                                        <div className="no-comment-text">
                                          <small>Too few stakeholder responses to display results
                                            for this questions.</small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            })}
                        </div>
                      </div>
                    </React.Fragment>)}
                <RenderIf showComponent={optionalCommentRightPanel.showCustomQuestionOption}>
                  {(roles.projectAdministrator || roles.portfolioAdministrator || isSysAdmin) && <div className="comments-heading-wrap1 p-28">
                    <h6>Ask more questions ?</h6>
                  </div>}
                  {(roles.projectAdministrator || roles.portfolioAdministrator || isSysAdmin) && <div class='card-body pt-0 px-2'>
                    <button
                      className={'a-btn a-btn-lg a-btn-secondary'}
                      disabled={(projectDraftedStatus && !isCustomAttribute) || !optionalCommentRightPanel.isProjectPortfolioActive}
                      onClick={() => this.setState({
                        showAddCustomQuestionModel: true,
                        questionModel: {},
                        isAutomatedQuestion: false,
                      })}>
                      <ReactSVG src={customQuestionSvg} />
                      {isCustomAttribute ? 'New question' : 'Custom question'}
                    </button>
                    {/**
                     * Remove the d-print-none d-none 
                     * when required to display again
                     */}
                    {!isCustomAttribute && <button
                      onClick={() => this.setState({
                        showAddCustomQuestionModel: true,
                        isAutomatedQuestion: true,
                      })}
                      disabled={autoQuesCount.length > 0 || disableAttribute || projectDraftedStatus || !optionalCommentRightPanel.isProjectPortfolioActive}
                      disable={true}
                      className={'a-btn a-btn-lg a-btn-secondary d-print-none d-none'}>
                      <ReactSVG src={autoGenerateQuestionSvg} />Auto generate Questions
                    </button>}
                  </div>}

                </RenderIf>
              </div>
            </div>
            <div className="show-title" >
              <h4 className="mb-0 title" style={{
                color: ' #c5c5c5',
                fontSize: '14px',
                textAlign: "center",
              }}>The views expressed in Perspectives are those provided by topic stakeholders and are not the views of PwC. </h4>
            </div>
          </RenderIf>
        </div>
        <RenderIf showComponent={showAddCustomQuestionModel}>
          <AddCustomQuestion
            projectId={portfolioData.selectedProjectId}
            domainId={optionalCommentRightPanel.domainID}
            attributeId={optionalCommentRightPanel.attributeId}
            domainName={optionalCommentRightPanel.domainTitle}
            attributeName={optionalCommentRightPanel.attributeTitle}
            questionDeployed={this.state.customQuestionDeployed}
            model={Object.keys(questionModel).length !== 0 ? questionModel : undefined}
            isCustomDomain={optionalCommentRightPanel.isCustomDomain}
            cancelClick={() => this.cancelCustomQuestion()}
            associatedStakeholdersCount={optionalCommentRightPanel.associatedStakeholdersCount}
            filterGroupValues={optionalCommentRightPanel.dSegments.includes(0) ?
              optionalCommentRightPanel.filterGroupValues : []}
            userFilterGroupValue={optionalCommentRightPanel.dSegments.includes(0) ?
              optionalCommentRightPanel.userFilterGroupValue : null}
            createSegment={optionalCommentRightPanel.dSegments.includes(0) ?
              optionalCommentRightPanel.filterGroupValues?.length > 0 ? 'yes' : 'no'
              : 'no'}
            selectedSegmentValue={optionalCommentRightPanel.selectedSegment}
            dSegments={optionalCommentRightPanel.dSegments}
            fromOptionalCommentSection={true}
            showWarningMessage={filterGroupValues.length ? !showWarningMessage : false}
            isAutomatedQuestion={isAutomatedQuestion}
            userSelectedFilterGroupValues={optionalCommentRightPanel.userFilterGroupValue}
          />
        </RenderIf>
        <RenderIf showComponent={showDeleteModal}>
          <DeleteConfirmation
            title={'Delete this question?'}
            message={[<p>You will lose all responses associated with this question.
              We can't recover them once you delete it.</p>, <p class="mb-0">Are you sure you want to <span className="deletemessage-color preview-pane-font">permanently delete</span> this question?</p>]}
            confirmationClick={() => this.deleteCustomQuestion()}
            cancelClick={() => this.setState({ showDeleteModal: false })}
            deleteButtomLabel={'Yes, delete it'}

          />
        </RenderIf>

      </React.Fragment >

    );
  }
}
OptionalCommentsRightPanel.propTypes = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OptionalCommentsRightPanel);
